import type { Resource } from '../../';
export const general_errors_notAvailable_bodyMessage1: Resource = {"default":"The page you have requested is not available."};
